import { render, staticRenderFns } from "./main-profile.vue?vue&type=template&id=7f5548da&scoped=true&"
import script from "./main-profile.vue?vue&type=script&lang=js&"
export * from "./main-profile.vue?vue&type=script&lang=js&"
import style0 from "./main-profile.vue?vue&type=style&index=0&id=7f5548da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5548da",
  null
  
)

export default component.exports